/*
 * AQS — interactive brand timeline. Drag / swipe / scroll a court-length
 * horizontal track. Fills a progress bar and reveals milestones as they
 * enter the track. Progressive: without JS it's still a native scroller.
 */
(function () {
  if (window.__aqsTimeline) return;
  window.__aqsTimeline = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(track) {
    var section = track.closest('.aqs-tl');
    var fill = section && section.querySelector('.aqs-tl__progress-fill');

    // Progress bar
    if (fill) {
      var raf = null;
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        fill.style.width = (max > 0 ? (track.scrollLeft / max) * 100 : 0) + '%';
        raf = null;
      };
      track.addEventListener(
        'scroll',
        function () {
          if (!raf) raf = requestAnimationFrame(update);
        },
        { passive: true }
      );
      update();
    }

    // Drag to scroll (mouse)
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // let native touch scroll handle it
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      down = false;
      track.classList.remove('is-dragging');
    });
    // Prevent link clicks after a drag
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    // Reveal milestones as they enter the track
    if (!reduce && section && 'IntersectionObserver' in window) {
      section.classList.add('aqs-tl--js');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add('is-in');
              io.unobserve(en.target);
            }
          });
        },
        { root: track, threshold: 0.35 }
      );
      track.querySelectorAll('.aqs-tl__item').forEach(function (it) {
        io.observe(it);
      });
      // Fail-safe: settle anything the observer misses.
      setTimeout(function () {
        track.querySelectorAll('.aqs-tl__item:not(.is-in)').forEach(function (it) {
          it.classList.add('is-in');
        });
      }, 800);
    } else {
      track.querySelectorAll('.aqs-tl__item').forEach(function (it) {
        it.classList.add('is-in');
      });
    }
  }

  function init() {
    document.querySelectorAll('.aqs-tl__track').forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
